import { ContentSkeleton } from '../ContentSkeleton';
import { SkeletonRect } from '../Skeleton';

export function AppSkeleton(): JSX.Element {
  return <div className="flex h-[100vh] supports-[height:100dvh]:h-[100dvh] flex-col overflow-hidden bg-bg">
    <div aria-hidden="true" className="flex h-14 shrink-0 items-center justify-between border-b border-line bg-panel px-5">
      <SkeletonRect width={150} height={24} /><SkeletonRect width={180} height={24} />
    </div>
    <div className="flex min-h-0 flex-1">
      <aside aria-hidden="true" className="hidden w-[210px] shrink-0 space-y-5 border-r border-line bg-panel p-5 md:block">
        {[0, 1, 2, 3, 4].map(i => <SkeletonRect key={i} height={26} className="w-full" />)}
      </aside>
      <div className="min-w-0 flex-1 overflow-auto p-6">
        <ContentSkeleton label="관리자 화면을 불러오는 중…" variant="cards" />
      </div>
    </div>
  </div>;
}
